import { readableColor } from 'polished';

export default function getSafeReadableColor(color) {
  try {
    return readableColor(color, '#000000', '#ffffff');
  } catch (e) {
    return '#000000';
  }
}
